<script lang="ts">
  import ProgressBarTime from '../components/ProgressBarTime.svelte'
  import { getProgressBarContext } from '../progressBarContext'

  type Props = {
    currentTime: number
    endTime: number
  }

  let { currentTime, endTime }: Props = $props()
  const progressBarContext = getProgressBarContext()
</script>

{#if !progressBarContext.hoverTime}
  <!-- Current time -->
  <ProgressBarTime seconds={currentTime} class="left-0" />
  <!-- Duration -->
  <ProgressBarTime seconds={endTime} class="right-0" />
{/if}
